<!-- Responsibility: Admin FORGING tab - Reality generation and management.
Scope: Reality ledger and preforge workspace. -->
<admin-forging-tab>
  <div class="admin-tab-content forging-tab">
    <aside class="ledger-column">
      <reality-ledger-sidebar
        loading={ props.state.loading }
        is-admin={ props.state.isAdmin }
        ledger-filter={ state.ledgerFilter }
        offers={ ledgerOffers() }
        selected-id={ props.state.selectedOfferId }
        on-initiate={ props.onInitiate }
        on-filter-input={ handleLedgerFilterInput }
        on-select={ props.onSelect }
      ></reality-ledger-sidebar>
    </aside>

    <section class="workspace-column">
      <header class="workspace-header">
        <div class="header-main">
          <h2>{ props.state.preforgeComposerHeading }</h2>
          <p class="admin-copy">{ props.state.preforgeComposerCopy }</p>
        </div>
        <div class="header-meta">
          <span class="status-pill" data-status={ props.state.selectedOfferStatus }>{ props.state.selectedOfferStatus }</span>
          <span class="record-id">{ props.state.selectedOfferId || 'IDLE' }</span>
        </div>
      </header>

      <p if={ props.state.preforgeMessage } class="admin-note">{ props.state.preforgeMessage }</p>

      <preforge-workspace-processing
        if={ props.state.preforgeComposerMode === 'processing' }
        title={ props.state.preforgeProgressTitle }
        copy={ props.state.preforgeProgressCopy }
        lines={ props.state.preforgeProgressLines }
      ></preforge-workspace-processing>

      <preforge-blocking-notice
        if={ props.state.preforgeBlockingNotice }
        notice={ props.state.preforgeBlockingNotice }
        on-action={ props.onOpenAiSettings }
        on-dismiss={ props.onDismissNotice }
      ></preforge-blocking-notice>

      <preforge-workspace-composer
        ref="composer"
        mode={ props.state.preforgeComposerMode }
        offer={ props.state.currentOffer }
        offer-id={ props.state.selectedOfferId }
        locked={ props.state.preforgeComposerLocked }
        brief={ props.state.preforgeComposerBrief }
        on-brief-input={ props.onBriefInput }
      ></preforge-workspace-composer>

      <div class="admin-actions">
        <button if={ props.state.preforgeComposerMode === 'brief' } type="button" class="action-btn primary" onclick={ props.onProcessBrief }>PROCESS BRIEF</button>
        <button if={ props.state.preforgeComposerMode === 'form' && props.state.preforgeComposerLocked } type="button" class="action-btn subtle" onclick={ props.onUnlockForm }>ENRICH</button>
        <button if={ props.state.preforgeComposerMode === 'form' } type="button" class="action-btn subtle" onclick={ props.onCloneVersion }>NEW VERSION</button>
        <button if={ props.state.preforgeComposerMode === 'form' } type="button" class="action-btn primary" onclick={ onRealize }>REALIZE REALITY</button>
        <button type="button" class="action-btn" onclick={ props.onResetForm }>CANCEL</button>
      </div>
    </section>
  </div>

  <script>
    import RealityLedgerSidebar from './reality-ledger-sidebar.riot'
    import PreforgeWorkspaceProcessing from './preforge-workspace-processing.riot'
    import PreforgeBlockingNotice from './preforge-blocking-notice.riot'
    import PreforgeWorkspaceComposer from './preforge-workspace-composer.riot'

    export default {
      components: {
        RealityLedgerSidebar, PreforgeWorkspaceProcessing, PreforgeBlockingNotice, PreforgeWorkspaceComposer
      },

      state: {
        ledgerFilter: ''
      },

      ledgerOffers() {
        const filter = this.state.ledgerFilter.toLowerCase()
        return this.props.state.preforgedOffers.filter(o => 
          !filter || o.id.toLowerCase().includes(filter) || (o.title || '').toLowerCase().includes(filter)
        )
      },

      handleLedgerFilterInput(e) {
        this.update({ ledgerFilter: e.target.value })
      },

      onRealize() {
        const values = this.$('preforge-workspace-composer').getValues()
        this.props.onRealize(values)
      }
    }
  </script>

  <style>
    .forging-tab {
      display: grid;
      grid-template-columns: 18.75rem 1fr;
      gap: var(--space-lg);
      background: var(--bg-deep);
      border-radius: 1rem;
      border: 1px solid var(--border);
      min-height: 70vh;
      overflow: hidden;
    }

    .ledger-column {
      border-right: 1px solid var(--border);
      background: var(--surface-card);
    }

    .workspace-column {
      padding: var(--space-lg);
      display: grid;
      grid-template-rows: auto auto 1fr auto;
      gap: var(--space-md);
      overflow-y: auto;
    }

    .workspace-header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
    }

    .header-main h2 { margin: 0; }
    .header-meta { text-align: right; display: grid; gap: 0.25rem; }

    .status-pill {
      padding: 0.25rem 0.75rem;
      border-radius: 2rem;
      font-size: 0.7rem;
      font-weight: bold;
      background: var(--surface-raised);
      border: 1px solid var(--border);
    }
    .status-pill[data-status="PUBLISHED"] { color: var(--success); border-color: var(--success); }

    .record-id { font-family: monospace; font-size: 0.7rem; color: var(--text-muted); }

    .admin-actions {
      display: flex;
      gap: var(--space-sm);
      padding-top: var(--space-md);
      border-top: 1px solid var(--border);
      justify-content: flex-end;
    }
  </style>
</admin-forging-tab>
